import Vue from "vue";

export default {
	state: {
		actualIdClient: 0,
		countries: [],
		ufs: [],
		address: {}
	},
	mutations: {
		setActualIdClientOnState(state, idClient) {
			state.actualIdClient = idClient;
		},
		setCountries(state, countries) {
			state.countries = countries;
		},
		setUfs(state, ufs) {
			state.ufs = ufs;
		},
		setAddressByCEP(state, address) {
			state.address = address;
		}
	},
	actions: {
		createOfferNoAuth(_, supplierOffer) {
			this.state.loading = true;

			return new Promise(async (resolve, reject) => {
				try {
					const mappedSupplierOffer = await mapSupplierOffersToBack(supplierOffer);
					const formData = new FormData();

					for (const file of supplierOffer.attach || []) {
						formData.append("files", file);
					}

					for (const key in mappedSupplierOffer) {
						const value = mappedSupplierOffer[key];

						if (Array.isArray(value)) {
							value.forEach((v) => formData.append(key, v));
						} else if (value !== undefined && value !== null) {
							formData.append(key, value);
						}
					}

					const response = await Vue.prototype.$http.post("noAuth/Offer/New/", formData);

					this.state.loading = false;
					resolve(response.data.data);
				} catch (err) {
					this.state.loading = false;

					if (err.response && err.response.data) {
						reject(err.response.data.error.message);
					}
				}
			});
		},
		getCompaniesByIdClientNoAuth({ commit }, clientKey) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get(`noAuth/Company/Client/${clientKey}`)
					.then((response) => {
						commit("setCompaniesOnState", response.data.data);
						resolve(response.data.data);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getCompaniesByGroupNoAuth({ commit }, clientKey) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get(`noAuth/CompanyByGroup/${clientKey}`)
					.then((response) => {
						commit("setCompaniesOnState", response.data.data);
						resolve(response.data.data);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getCheckClientKey(_, clientKey) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("client/getCheck/" + clientKey).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		getFamiliesNoAuth({ commit }, filter) {
			this.state.loading = true;
			if (!filter) filter = {};
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("noAuth/filter/", filter)
					.then((response) => {
						this.state.loading = false;
						commit("setFamiliesOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getFamilyChildrensNoAuth({ commit }, params) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("noAuth/childrens/" + params.idFamily + "/client/" + params.key)
					.then((response) => {
						this.state.loading = false;
						commit("setFamilyChildrenOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getFamiliesNamesNoAuth(_, dataObject) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("noAuth/family/name", dataObject).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		sendEmailNoAuth(_, data) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("noAuth/email", data)
					.then(
						(response) => {
							resolve(response);
						},
						(reason) => {
							reject(reason);
						}
					)
					.catch((error) => reject(error));
			});
		},
		getCountriesNoAuth({ commit }, data) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("noAuth/location/country", data)
					.then((response) => {
						commit("setCountries", response.data.data);
						resolve(response);
					})
					.catch((error) => {
						console.error(error.message);
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		getUfsNoAuth({ commit }, data) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("noAuth/location/state", data)
					.then((response) => {
						commit("setUfs", response.data.data);
						resolve(response);
					})
					.catch((error) => {
						console.error(error.message);
					});
			});
		},
		async getAddressByCEP({ commit }, cep) {
			cep.replace("-", "");
			this.state.loading = true;
			try {
				return await new Promise((resolve) => {
					Vue.prototype.$http
						.getExternal(`https://viacep.com.br/ws/${cep}/json/`)
						.then((response) => {
							commit("setAddressByCEP", response.data);
							resolve(response.data);
						})
						.catch((error) => {
							reject(error);
						})
						.finally(() => {
							this.state.loading = false;
						});
				});
			} catch {
				this.state.loading = false;
				throw error;
			}
		},
		consumeSession(_, sessionData) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("sessions/consume", sessionData, { isIframeContext: true })
					.then(
						(response) => {
							resolve(response);
						},
						(error) => {
							reject(error);
						}
					)
					.catch((error) => reject(error))
					.finally(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		countries({ countries }) {
			return countries;
		},
		ufs({ ufs }) {
			return ufs;
		},
		address({ address }) {
			return address;
		}
	}
};

const mapSupplierOffersToBack = (supplierOffersToBack) => {
	return new Promise((resolve) => {
		let retObject = {
			name: supplierOffersToBack.name,
			cnpjCpf: supplierOffersToBack.cnpjCpf,
			contact: supplierOffersToBack.contact,
			email: supplierOffersToBack.email,
			message: supplierOffersToBack.message,
			family: supplierOffersToBack.family,
			company: supplierOffersToBack.companyName.filter(Number),
			country: supplierOffersToBack.country,
			uf: supplierOffersToBack.uf,
			birthDate: supplierOffersToBack.birthDate,
			key: supplierOffersToBack.key,
			parentCnpjCpf: supplierOffersToBack.parentCnpjCpf,
			personType: supplierOffersToBack.personType
		};
		resolve(retObject);
	});
};
